import React, { Component } from "react";
import ChartistGraph from "react-chartist";
//import { ClipLoader } from "react-spinners";
import ClipLoader from "react-spinners/RingLoader";
import { Grid, Row, Col, FormGroup, InputGroup,ControlLabel,FormControl} from "react-bootstrap";
import { Bar } from 'react-chartjs-2';
import { auth, db } from "firedb/firebase";
import ReactEcharts from 'echarts-for-react';

import { Card } from "components/Card/Card.jsx";
import { StatsCard } from "components/StatsCard/StatsCard.jsx";
import {
    dataPie,
    legendPie,
    dataSales,
    clientsActive,
    clientsNew,
    responsiveSales,
    legendSales,
} from "variables/Variables.jsx";

import './company.css';

// import './Grafic.css';

const option = {
    title: {
        text: 'Клиенты'
    },
    
    backgroundColor: '#fff',

    colors : ['#cccccc','#2f4554', '#61a0a8', '#d48265', '#91c7ae','#749f83',  '#ca8622', '#bda29a','#6e7074', '#546570', '#c4ccd3'],

    tooltip: {},
    legend: {
        data:['Sales'],
    },
    xAxis: {
        data: ["june","july","august","september","october","november", "december", "january", "febrary", "march", "april", "may",
        "june","july","august","september","october","november", "december", "january", "febrary", "march", "april", "may",
        "june","july","august","september","october","november", "december", "january", "febrary", "march", "april", "may"]
    },
    dataZoom: [
        {
            type: 'inside'
        }
    ],
    yAxis: {},
    series: [{
        // name: 'Sales',
        type: 'line',
        data: [5, 5, 5, 5, 5, 5, 5, 32, 36, 10, 25, 45, 5, 20, 36, 10, 10, 20,30, 32, 36, 10, 25, 45, 5, 20, 36, 10, 10, 20,30, 32, 36, 10, 25, 45]
    }],
};



const data = {
    labels: ['Red', 'Blue', 'Yellow', 'Green', 'Purple', 'Orange'],
    datasets: [
        {
        label: 'Зачислено',
        type: 'line',
        data: [12, 19, 3, 5, 2, 3],
        backgroundColor: [
            'rgba(255, 159, 64, 0)',
        ],
        borderColor: [
            'rgba(154, 162, 235, 1)',
        ],

        },
        {
            label: 'Списано  баллов',
            type: 'line',
            data: [10, 12, 5, 4, 3, 4],
            backgroundColor: [
                'rgba(255, 159, 64, 0)',
            ],
            borderColor: [
                'rgba(54, 162, 235, 1)',
            ],

        },
    ]
};

const data2 = {
    labels: ['Red', 'Blue', 'Yellow', 'Green', 'Purple', 'Orange'],
    datasets: [
        {
            label: 'Активных за период',
            type: 'line',
            data: [11, 17, 5, 4, 3, 4],
            backgroundColor: [
                'rgba(255, 159, 64, 0)',
            ],
            borderColor: [
                'rgba(64, 162, 35, 1)',
            ],

        },
        {
            label: 'Неактивные за период',
            type: 'line',
            data: [15, 1, 5, 4, 3, 4],
            backgroundColor: [
                'rgba(255, 159, 64, 0)',
            ],
            borderColor: [
                'rgba(54, 62, 35, 1)',
            ],

        },
        {
            label: 'Новые клиенты',
            type: 'line',
            data: [15, 1, 5, 4, 3, 4],
            backgroundColor: [
                'rgba(255, 159, 64, 0)',
            ],
            borderColor: [
                'rgba(254, 42, 15, 1)',
            ],

        },
    ]
};

const override = `
  display: block;
  margin: auto;
  border-color: red;  
  z-index:99999999;
`;

const init_state = {
    NumClients: 0,
    NumActiveClients: 0,
    SumClientPoints: 0,
    AvgObtain: 0,
    AvgSpend: 0,
    CompanyUID: '',
    dataOrder: data, //данные для графика по клиентам
    dataClient: data2, //данные для графиков по начислениям
    firstDate: '', //дата начала периода
    lastDate: '', //дата окончания периода
    NumClientsPeriod: 0, //колличество клиентов на данный период
    NumNewClientsPeriod: 0, //колличество новых клиентов
    selectForm: 1, //тип периода по умолчанию сегодня
    regularClient: 0,
    loading: true,
};





class Company extends Component {

    constructor(props) {
        super(props);
        this.state = {...init_state};
        this.dataCompani = {};
        this.valData = {};
        this.onSetfristDate = this.onSetfristDate.bind(this);
        this.onSetLastDate = this.onSetLastDate.bind(this);
        this.onSetInterval = this.onSetInterval.bind(this);
    }


    componentWillMount() {
        this.setState({loading: true});
        db.ref('admin/' + auth.currentUser.uid).once('value').then(snapshot => {
            this.setState({CompanyUID: snapshot.val().company});
            db.ref('transaction_company/' + this.state.CompanyUID).once('value').then(snapshot => {
                if (snapshot.val()) {
                    this.setState({NumClients: Object.keys(snapshot.val()).length})

                } else {
                    this.setState({NumClients: 0})
                }

                this.getClients(snapshot.val());
                this.getSumClientPoints(snapshot.val());
                this.dataCompani = snapshot; //сохраняем массив чтоб не грузить инет клиента
                let now = new Date().toISOString().substr(0, 10);
                this.setState({firstDate: now});
                this.setState({lastDate: now});
                this.getNewMassivClients(this.dataCompani.val());
                this.getClients(this.valData, Date.parse(now));
                this.getCountClients(this.valData, Date.parse(now));
                this.getCountRegularClient(snapshot.val());
                this.setState({loading: false});
            })
        })
    }

    getCountRegularClient(all_data): void {
        let m1 = {};
        let dt = 0;
        let z = '';
        for (let client_scans in all_data) {
            for (let scan in all_data[client_scans]) {
                dt = new Date(all_data[client_scans][scan]['timestamp']).toISOString().substr(0, 7);
                if(z != client_scans) {
                    z = client_scans;
                    m1[client_scans] = {};
                    m1[client_scans][dt] = 1;
                } else {
                    if (dt in m1[client_scans]){
                        m1[client_scans][dt]+=1;
                    } else {
                        m1[client_scans][dt]=1;
                    }

                }

            }
        }
        let h = 0;
        for (let client_scans in m1) {
            if (Object.keys(m1[client_scans]).length >5) {
                h+=1;
            }
        }
        this.state.regularClient = h;
    }
// вычисления для графиков
    getCountClients(all_data, fdt=0, ldt=0): void {
        let timePeriod = {};
        let d = 0;
        let l = 0;
        if (fdt==0) {
            let d1 = Date.parse(this.state.firstDate);
            d = d1;
        } else {
            d = fdt;
        }
        if (ldt==0) {
            let d1 = Date.parse(this.state.lastDate);
            l=d1;
        } else {
            l=ldt;
        }
        l += 86400000;
        let dt = 0;
        let kl = 0;
        let y = false;
        let z = '';
        for (let client_scans in all_data) {
            y = false;
                for (let scan in all_data[client_scans]) {
                    if ((y==false) && (all_data[client_scans][scan]['timestamp'] < d)) {
                        kl +=1;
                        y=true;
                    }
                    if ((all_data[client_scans][scan]['timestamp'] >= d) && (all_data[client_scans][scan]['timestamp'] <= l)) {
                        let newCl = 0;
                        // let v = new Date(all_data[client_scans][scan]['timestamp']).toISOString().substr(0, 10).split("-");
                        // dt = v[2]+"."+v[1]+"."+v[0];
                        dt = new Date(all_data[client_scans][scan]['timestamp']).toISOString().substr(0, 10);
                        if (dt in timePeriod){
                            if (y==false) {
                                timePeriod[dt]['k'] +=1;
                                y=true;
                            }
                            if(all_data[client_scans][scan]['points'] > 0) {
                                timePeriod[dt]['z'] += all_data[client_scans][scan]['points'];
                            } else {
                                timePeriod[dt]['s'] += all_data[client_scans][scan]['points'];
                            }
                            if(z != client_scans) {
                                timePeriod[dt]['a'] +=1;
                                timePeriod[dt]['n'] -=1;
                                z = client_scans;
                            }


                        } else {
                            z = client_scans;
                            if (y==false) {
                                newCl = 1;
                                y=true;
                            }
                            if(all_data[client_scans][scan]['points'] > 0) {
                                timePeriod[dt] = {
                                    'z': all_data[client_scans][scan]['points'],
                                    's': 0,
                                    'a': 1,
                                    'n': (this.state.NumClientsPeriod-1),
                                    'k': newCl,
                                };
                            } else {
                                timePeriod[dt] = {
                                    'z': 0,
                                    's': all_data[client_scans][scan]['points'],
                                    'a': 1,
                                    'n': (this.state.NumClientsPeriod-1),
                                    'k': newCl,
                                };
                            }

                        }

                    }
                }
        }
        let m1 = [];
        let activ = [];
        let passiv = [];
        let newCl = [];
        let uporder = [];
        let downorder = [];
        const keys = Object.keys(timePeriod).sort();
        for (let i=0; i<keys.length;i++){
            let v = keys[i].split("-");
            m1.push(v[2]+"."+v[1]+"."+v[0]);
            activ.push(timePeriod[keys[i]]['a']);
            kl=kl+timePeriod[keys[i]]['k']
            passiv.push(kl);
            uporder.push(timePeriod[keys[i]]['z']);
            downorder.push(timePeriod[keys[i]]['s']*(-1));
            newCl.push(timePeriod[keys[i]]['k'])
        }
        let n = this.state.dataClient;
        let m = this.state.dataOrder;

        n['labels'] = m1;
        n['datasets'][0]['data'] = activ;
        n['datasets'][1]['data'] = passiv;
        n['datasets'][2]['data'] = newCl;
        m['labels'] = m1;
        m['datasets'][0]['data'] = uporder;
        m['datasets'][1]['data'] = downorder;
        this.setState({
            dataClient: n,
            dataOrder: m,
        });
    }
//получение обрезанного массива клиетов для более удобной работы
    getNewMassivClients(all_data, fdt=0, ldt=0): void {
        this.valData = {}
        let d = 0;
        let l = 0;
        if (fdt==0) {
            let d1 = Date.parse(this.state.firstDate);
            d = d1;
        } else {
            d = fdt;
        }
        if (ldt==0) {
            let d1 = Date.parse(this.state.lastDate);
            l=d1;
        } else {
            l=ldt;
        }
        l += 86400000;
        let newClients = 0;
        let numClientAll = 0;
        let ff = false;
        for (let client_scans in all_data) {
            ff = false;
            internal_loop:
                for (let scan in all_data[client_scans]) {
                    if ((all_data[client_scans][scan]['timestamp'] < d) && (ff==false)) {
                        ff = true;
                        numClientAll += 1;
                    }
                    if ((all_data[client_scans][scan]['timestamp'] >= d) && (all_data[client_scans][scan]['timestamp'] <= l)) {
                        this.valData[client_scans] = all_data[client_scans];
                        if (ff == false) {
                            newClients +=1;
                            numClientAll += 1;
                        }
                        break internal_loop;
                    }
                }
        }
        this.setState({NumClientsPeriod: numClientAll});
        this.setState({NumNewClientsPeriod: newClients});
    }
//функция получения активных клиентов за период
    getClients(all_data, fdt=0, ldt=0): void {
        let d = 0;
        let l = 0;
        if (fdt==0) {
            let d1 = Date.parse(this.state.firstDate);
            d = d1;
        } else {
            d = fdt;
        }
        if (ldt==0) {
            let d1 = Date.parse(this.state.lastDate);
            l=d1;
        } else {
            l=ldt;
        }
        l += 86400000;

        let active_clients = 0;
        for (let client_scans in all_data) {
            internal_loop:
            for (let scan in all_data[client_scans]) {
                    if ((all_data[client_scans][scan]['timestamp'] >= d) && (all_data[client_scans][scan]['timestamp'] <= l)) {
                        active_clients += 1;
                        break internal_loop;
                    }
            }
        }
        this.setState({NumActiveClients: active_clients});

    }
// получение данных по периоду
    getSumClientPoints(all_data): void {
        let num = 0;
        let sum = 0;
        let obtain_num = 0;
        let obtain_sum = 0;
        let spend_num = 0;
        let spend_sum = 0;
        for (let client_scans in all_data) {
            for (let scan in all_data[client_scans]) {
                if (all_data[client_scans][scan]['points'] >= 0) {
                    obtain_num += 1;
                    obtain_sum += all_data[client_scans][scan]['points'];
                } else {
                    spend_num += 1;
                    spend_sum += all_data[client_scans][scan]['points'];
                }
                num += 1;
                sum += all_data[client_scans][scan]['points'];
            }
        }
        this.setState({SumClientPoints: sum});
        this.setState({AvgObtain: (obtain_sum / obtain_num) || 0 })
        this.setState({AvgSpend: -(spend_sum / spend_num) || 0 })

    }

    getAvgObtain(all_data): void {

    }
//функция обработки компнента начала периода
    onSetfristDate(event) {
        let y = event.target.value;
        let dt = Date.parse(y);
        this.setState(state=> ({
            firstDate: y,
            selectForm: 5,
        }));
        this.getNewMassivClients(this.dataCompani.val(), dt);
        this.getClients(this.valData, dt);
        this.getCountClients(this.dataCompani.val(), dt);
    }
//функция обработки компнента окончания периода
    onSetLastDate(event) {
        //alert(event.target.value);
        let y = event.target.value
        let dt = Date.parse(y);
        this.setState(state=> ({
            lastDate: y,
            selectForm: 5,
        }));
        this.getNewMassivClients(this.dataCompani.val(), 0, dt);
        this.getClients(this.valData, 0, dt);
        this.getCountClients(this.dataCompani.val(), 0, dt);
    }
//функция обработки компнента выбора периода
    onSetInterval(event) {
        let intr = event.target.value;
        let d = new Date();
        let now = new Date().toISOString().substr(0, 10);
        if (intr == 1) {
            this.setState(state=> ({
                firstDate: now,
                lastDate: now,
                selectForm: 1,
            }));
            this.getNewMassivClients(this.dataCompani.val(), Date.parse(now), Date.parse(now));
            this.getClients(this.valData, Date.parse(now), Date.parse(now));
            this.getCountClients(this.dataCompani.val(), Date.parse(now), Date.parse(now));
        }
        if (intr == 2) {
            d.setDate(d.getDate() - 7);
            let dt = new Date(d).toISOString().substr(0, 10);
            this.setState(state=> ({
                firstDate: dt,
                lastDate: now,
                selectForm: 2,
            }));
            this.getNewMassivClients(this.dataCompani.val(), Date.parse(dt), Date.parse(now));
            this.getClients(this.valData, Date.parse(dt), Date.parse(now));
            this.getCountClients(this.dataCompani.val(), Date.parse(dt), Date.parse(now));
        }
        if (intr == 3) {
            d.setDate(d.getDate() - 30);
            let dt = new Date(d).toISOString().substr(0, 10);
            this.setState(state=> ({
                firstDate: dt,
                lastDate: now,
                selectForm: 3,
            }));
            this.getNewMassivClients(this.dataCompani.val(), Date.parse(dt), Date.parse(now));
            this.getClients(this.valData, Date.parse(dt), Date.parse(now));
            this.getCountClients(this.dataCompani.val(), Date.parse(dt), Date.parse(now));
        }
        if (intr == 4) {
            d.setMonth(d.getMonth() - 4);
            let dt = new Date(d).toISOString().substr(0, 10);
            this.setState(state=> ({
                firstDate: dt,
                lastDate: now,
                selectForm: 4,
            }));
            this.getNewMassivClients(this.dataCompani.val(), Date.parse(dt), Date.parse(now));
            this.getClients(this.valData, Date.parse(dt), Date.parse(now));
            this.getCountClients(this.dataCompani.val(), Date.parse(dt), Date.parse(now));
        }
    }

    // createLegend(json) {
    //     var legend = [];
    //     for (var i = 0; i < json["names"].length; i++) {
    //         var type = "fa fa-circle text-" + json["types"][i];
    //         legend.push(<i className={type} key={i} />);
    //         legend.push(" ");
    //         legend.push(json["names"][i]);
    //     }
    //
    //     return legend;
    // }

    render() {
        return (

    <div className="content">
            <ClipLoader
                size={150}
                //size={"150px"} this also works
                css={override}
                color={"#e77817"}
                loading={this.state.loading}
            />
    <Grid fluid>
        <Row>
            <Col>
                <div className="col-md-4">
                    <FormGroup controlId="formControlsSelect">
                        <ControlLabel>Период</ControlLabel>
                        <FormControl componentClass="select" placeholder="select" onChange={this.onSetInterval} value={this.state.selectForm}>
                            <option value="1">сегодня</option>
                            <option value="2">7 дней</option>
                            <option value="3">30 дней</option>
                            <option value="4">Квартал</option>
                            <option value="5">Свой</option>
                        </FormControl>
                    </FormGroup>
                </div>

                <div className="col-md-4">
                    <FormGroup>
                        <ControlLabel>Дата начала периода</ControlLabel>
                        <FormControl
                            type="date"
                            bsClass="form-control"
                            value = {this.state.firstDate}
                            onChange={this.onSetfristDate}
                        />
                    </FormGroup>
                </div>
                <div className="col-md-4">
                    <FormGroup>
                        <ControlLabel>Дата окончания периода</ControlLabel>
                        <FormControl
                            type="date"
                            bsClass="form-control"
                            value = {this.state.lastDate}
                            onChange={this.onSetLastDate}
                        />
                    </FormGroup>
                </div>
            </Col>
        </Row>
        <Row>
            <Col>
                <div>
                    <h2>График активности клиентов</h2>
                    <Bar ref="chart" data={this.state.dataClient} />
                </div>
            </Col>
        </Row>
        <Row>
            <Col>
                <div>
                    <h2>График движения баллов</h2>
                    <Bar ref="chart" data={this.state.dataOrder} />
                </div>
            </Col>
        </Row>
      <Row>
        <Col lg={4} md={6} sm={6}>
          <StatsCard
            bigIcon={<i className="pe-7s-users text-warning" />}
            statsText="Клиенты"
            statsValue={this.state.NumClients}
            statsIconText="Общее количество клиентов"
            style={"height:214px"}
          />
        </Col>
        <Col lg={4} md={6} sm={6}>
          <StatsCard
            bigIcon={<i className="pe-7s-star text-danger" />}
            statsText="Активные клиенты"
            statsValue={this.state.NumActiveClients}
            statsIconText="Клиенты, совершившие покупку за период"
          />
        </Col>
        {/*<Col lg={3} sm={6}>*/}
          {/*<StatsCard*/}
            {/*bigIcon={<i className="fa pe-7s-angle-right-circle text-info" />}*/}
            {/*statsText="Транзакция в неделю"*/}
            {/*statsValue="107"*/}
          {/*/>*/}
        {/*</Col>*/}
      </Row>
      <Row>
        <Col lg={4} md={6} sm={6}>
          <StatsCard
            bigIcon={<i className="pe-7s-cash text-warning" />}
            statsText="Среднее зачисление"
            statsValue={this.state.AvgObtain.toFixed(2) + " \u20bd"}
            statsIconText="Среднее зачисление баллов, учитывая статистику за все время по вашим клиентам"
          />
        </Col>
        <Col lg={4} md={6} sm={6}>
          <StatsCard
            bigIcon={<i className="pe-7s-cash text-danger" />}
            statsText="Среднее списание"
            statsValue={this.state.AvgSpend.toFixed(2) + " \u20bd"}
            statsIconText="Среднее списание баллов, учитывая статистику за все время по вашим клиентам"
          />
        </Col>
        {/*<Col md={8}>*/}
            {/*<ReactEcharts*/}
                {/*option={option}*/}
                {/*notMerge={true}*/}
                {/*lazyUpdate={true}*/}
                {/*theme={"theme_name"}*/}
            {/*/>*/}
    {/*/!*              <Card*/}
            {/*statsIcon="fa fa-history"*/}
            {/*id="chartHours"*/}
            {/*title="Клиенты"*/}
            {/*category="Клиенты, зарегистрированные в системе"*/}
            {/*content={*/}
              {/*<div className="ct-chart">*/}
                {/*<ChartistGraph*/}
                  {/*data={dataSales}*/}
                  {/*type="Line"*/}
                  {/*options={clientsActive}*/}
                  {/*responsiveOptions={responsiveSales}*/}
                {/*/>*/}
              {/*</div>*/}
            {/*}*/}
            {/*legend={*/}
              {/*<div className="legend">{this.createLegend(legendSales)}</div>*/}
            {/*}*/}
          {/*/>*/}
    {/**!/            */}
    {/*</Col>*/}
        {/*<Col md={4}>*/}
          {/*<Card*/}
            {/*statsIcon="fa fa-clock-o"*/}
            {/*title="Категории клиентов"*/}
            {/*category="Соотношение новых, активных и неактивных клиентов"*/}
            {/*content={*/}
              {/*<div*/}
                {/*id="chartPreferences"*/}
                {/*className="ct-chart ct-perfect-fourth"*/}
              {/*>*/}
                {/*<ChartistGraph data={dataPie} type="Pie" />*/}
              {/*</div>*/}
            {/*}*/}
            {/*legend={*/}
              {/*<div className="legend">{this.createLegend(legendPie)}</div>*/}
            {/*}*/}
          {/*/>*/}
        {/*</Col>*/}
      </Row>

      <Row>
        <Col lg={4} md={6} sm={6}>
          <StatsCard
            bigIcon={<i className="pe-7s-cash text-success" />}
            statsText="Накоплено клиентами"
            statsValue={this.state.SumClientPoints + " \u20bd"}
            statsIconText="На данный момент это количество баллов находится на счетах всех ваших клиентов, и доступно для списания"
          />
        </Col>
          <Col lg={4} md={6} sm={6}>
              <StatsCard
                  bigIcon={<i className="pe-7s-users text-warning" />}
                  statsText="Итого клиентов за период"
                  statsValue={this.state.NumClientsPeriod}
                  statsIconText="Колличество клиентов за выбранный период"
              />
          </Col>
        {/*<Col md={8}>*/}
          {/*<Card*/}
            {/*statsIcon="fa fa-history"*/}
            {/*id="chartHours"*/}
            {/*title="Активные клиенты"*/}
            {/*category="Клиенты, посещавшие заведение в течении последних 30 дней"*/}
            {/*content={*/}
              {/*<div className="ct-chart">*/}
                {/*<ChartistGraph*/}
                  {/*data={dataSales}*/}
                  {/*type="Line"*/}
                  {/*options={clientsActive}*/}
                  {/*responsiveOptions={responsiveSales}*/}
                {/*/>*/}
              {/*</div>*/}
            {/*}*/}
            {/*legend={*/}
              {/*<div className="legend">{this.createLegend(legendSales)}</div>*/}
            {/*}*/}
          {/*/>*/}
        {/*</Col>*/}

        {/*<Col md={8}>*/}
          {/*<Card*/}
            {/*statsIcon="fa fa-history"*/}
            {/*id="chartHours"*/}
            {/*title="Активные клиенты"*/}
            {/*category="Клиенты, впервые воспользовавшиеся сервисом"*/}
            {/*content={*/}
              {/*<div className="ct-chart">*/}
                {/*<ChartistGraph*/}
                  {/*data={dataSales}*/}
                  {/*type="Line"*/}
                  {/*options={clientsNew}*/}
                  {/*responsiveOptions={responsiveSales}*/}
                {/*/>*/}
              {/*</div>*/}
            {/*}*/}
            {/*legend={*/}
              {/*<div className="legend">{this.createLegend(legendSales)}</div>*/}
            {/*}*/}
          {/*/>*/}
        {/*</Col>*/}
      </Row>
        <Row>
            <Col lg={4} md={6} sm={6}>
                <StatsCard
                    bigIcon={<i className="pe-7s-users text-warning" />}
                    statsText="Новые за период"
                    statsValue={this.state.NumNewClientsPeriod}
                    statsIconText="Новые клиенты за выбранный период"
                />
            </Col>
            <Col lg={4} md={6} sm={6}>
                <StatsCard
                    bigIcon={<i className="pe-7s-like2 text-warning" />}
                    statsText="Постоянные клиенты"
                    statsValue={this.state.regularClient}
                    statsIconText="Количество клиентов, совершавших покупку минимум 1 раз в месяц на протяжении полугода (6 месяцев)"
                />
            </Col>
            {/*<Col lg={4} sm={6}>*/}
                {/*<StatsCard*/}
                    {/*bigIcon={<i className="fa fa-history" />}*/}
                    {/*statsText="Итого клиентов за период"*/}
                    {/*statsValue={this.state.SumClientPoints + " \u20bd"}*/}
                    {/*statsIconText="Колличество клиентов за выбранный период"*/}
                {/*/>*/}
            {/*</Col>*/}
        </Row>

    </Grid>
    </div>
        );
    }
}

export default Company;



// WEBPACK FOOTER //
// ./src/views/Company/Company.jsx